import { PropTypes } from "prop-types";
import React from "react";
import { getTimezoneName } from "~/helpers/timezone_helpers";
import TimeZones from "~/lib/time_zones";
import Select from "./SelectWrapper/Select";

const TimezoneSelect = ({
  id = "",
  name = "",
  value = "",
  placeholder = "Select a Time Zone",
  onChange = () => {},
  isInvalid = false,
  isClearable = false,
  isSearchable = true,
}) => {
  let { options } = TimeZones;

  const valueExists = options.some((option) => option.value === value);

  if (!valueExists && value) {
    const label = getTimezoneName(value);
    options = [...options, { label, value }];
  }

  return (
    <Select
      id={id}
      name={name}
      options={options}
      isInvalid={isInvalid}
      onChange={onChange}
      value={value}
      isClearable={isClearable}
      placeholder={placeholder}
      isSearchable={isSearchable}
    />
  );
};

TimezoneSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
  isInvalid: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
};

export default TimezoneSelect;
